<router-outlet></router-outlet>
<div class="rm-staging-block" *ngIf="staging"></div>
